// https://github.com/facebook/create-react-app/pull/9934#issuecomment-724833001
export const unmodule = (x) => x?.default ?? x;

export const getCsrfToken = () => {
  const csrfTokenElement = document.head.querySelector(
    'meta[name="csrf-token"]',
  );
  return csrfTokenElement.content;
};

export const addThousandSeparator = (value) => {
  if (value === "") {
    return;
  }
  value = value.replace(/\D/g, "");

  let valueCommaToken = value.toString().split(",");

  let valueBeforeComma = processValueBeforeComma(valueCommaToken[0]);
  let valueAfterComma = processValueAfterComma(valueCommaToken[1], value);

  return `${valueBeforeComma}${valueAfterComma}`;
};
const processValueBeforeComma = (value) => {
  let valuesBeforeComma = removeSeparatorNumber(value);

  let tempLengthRunning = valuesBeforeComma.length;
  for (let i = 0; tempLengthRunning > 3; i++) {
    tempLengthRunning -= 3;
    valuesBeforeComma.splice(tempLengthRunning, 0, ".");
  }

  return valuesBeforeComma.join("");
};
const processValueAfterComma = (value, currentValue) => {
  let result = value;

  if (result) {
    return `,${result}`;
  }

  if (currentValue[currentValue.length - 1] === ",") {
    return ",";
  }

  return "";
};
const removeSeparatorNumber = (number) => {
  let result = [];

  let token = number.split("");
  for (let i = 0; i < token.length; i++) {
    if (token[i] === ".") {
      continue;
    }

    result.push(token[i]);
  }

  return result;
};
